module.exports = __webpack_public_path__ + "static/sider-A4-feb8a4d369992bb38b57629e7a99fbe1.png";